function SitesUsers({ id }: any) {
  return <>Users {id}</>;
}

export default SitesUsers;
